"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTimeZoneStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.useTimeZoneStore = (0, pinia_1.defineStore)("timeZoneStore", {
    state: () => ({
        timeZone: "xxx",
    }),
    getters: {},
    actions: {
        async getTimeZone() {
            const response = await (0, fetch_1.default)(`/api/get-time-zone`, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            });
            const datas = (await response);
            if (datas === null || datas === void 0 ? void 0 : datas.timeZone) {
                this.timeZone = datas.timeZone;
            }
        },
    },
});
